/**
 * Attendance Calendar (Aanwezigheidskalender) Zod Schemas
 *
 * Epic 4, Story 4.1 — query-param validation for
 * `GET /api/v1/attendance-calendar` (AD-9: `requireAuth` + zod `safeParse`).
 */
import { z } from 'zod';
const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
/**
 * `van`/`tot` period query. Capped at 62 days (~2 maanden) as a defensive
 * guard against unbounded scans across the schedule/leave/holiday tables —
 * not an explicit AC requirement, a documented scope decision (a
 * dag/week/maand-kalender UI never needs a wider single fetch).
 */
export const attendanceCalendarQuerySchema = z
    .object({
    van: z.string().regex(isoDatePattern, 'Ongeldige datum (verwacht YYYY-MM-DD)'),
    tot: z.string().regex(isoDatePattern, 'Ongeldige datum (verwacht YYYY-MM-DD)'),
})
    .refine((data) => data.van <= data.tot, {
    message: '"van" moet voor of gelijk aan "tot" liggen',
    path: ['van'],
})
    .refine((data) => {
    const from = new Date(`${data.van}T00:00:00Z`);
    const to = new Date(`${data.tot}T00:00:00Z`);
    const diffDays = (to.getTime() - from.getTime()) / 86_400_000;
    return diffDays <= 62;
}, { message: 'Periode mag maximaal 62 dagen beslaan', path: ['tot'] });
//# sourceMappingURL=calendar.js.map